import useProductDetail from 'hooks/useProductDetail';
import Dp from 'icons/std/dp.svg';
import { PageMallSkuDetail } from 'libs/types';
import { Toast, Dialog } from 'react-vant';
import Button from '@/comps/Button';
import MmuSkuListPopupWithIcon from './MmuSkuListPopupWithIcon';
import { UserContext } from 'libs/contexts';
import { USER_AUTHRIZED_STATUS } from 'libs/enums';
import React, { useContext } from 'react';
import {checkConcreteAtribute} from 'api/order';
type ProductDetailAddToSkuListProps = {
  skuList: Array<MmuMallSku>;
  showUsePart: boolean;
  selectTradeAgreement: TradeAgreementInfo;
  shopInfo: Record<string, string>;
  skuDetail: PageMallSkuDetail;
  selectAccountPeriod: DiscountByMethodInfo;
  selectStation: Station;
  station: Array<Station>;
  disabled: boolean;
  btnTxt: string;
  source: string;
  tradeAgreementArr: any[];
  setSelectStation: (station: Station) => void;
  setSkuList: (skuList: Array<MmuMallSku>) => void;
};
export default function ProductDetailAddToSkuList({
  skuList,
  showUsePart,
  selectTradeAgreement,
  shopInfo,
  skuDetail,
  selectAccountPeriod,
  selectStation,
  station,
  disabled,
  btnTxt,
  source,
  setSelectStation,
  setSkuList,
  tradeAgreementArr,
}: ProductDetailAddToSkuListProps) {
  const { handleCreate, toShop, getTotalPrice } = useProductDetail();
  const userInfo = useContext(UserContext);
  const canBuy = () => {
    const isAuthrizedPurcharser =
      userInfo &&
      userInfo.isPurchaser &&
      [USER_AUTHRIZED_STATUS.AUDIT_PURCHASE, USER_AUTHRIZED_STATUS.AUDIT_BOTH].includes(
        userInfo.orgAuditType,
      );
    if (!isAuthrizedPurcharser) return false;
    const hasGerneralAgreement = tradeAgreementArr.filter(
      (item) => !item.tradeAgreementScope,
    ).length;
    const hasSpecificAgreement = tradeAgreementArr.filter(
      (item) => !!item.tradeAgreementScope,
    ).length;
    // 外部采购商
    if (!userInfo.isInside) {
      return isAuthrizedPurcharser && Boolean(hasGerneralAgreement || hasSpecificAgreement);
    }
    // 内部认证采购商
    if (userInfo.isInside) {
      return isAuthrizedPurcharser && hasSpecificAgreement;
    }
    return false;
  };
  const handleSubmit = () => {
    if (!skuList?.length) return Toast.info('请先选择商品及规格');
    
    console.log('check 111')
    const getCheckData = (sku) => {
      const attrs = ((sku.attributeList || []).concat(sku.mmuAttributeList || []))?.map(attr => ({
        attributeNo: attr.costCenterCode,
        attributeName: attr.attributeName,
        attributeValueList: attr.categoryAttributeValueList?.map(t => ({
          attributeValueNo: t.costCenterCode,
          attributeValueName: t.attributeValue,
        }))
      }))?.filter(item => item.attributeValueList?.length > 0)
      const data = {
        stationId: selectStation?.stationNo,
        attributeList: attrs
      }
      console.log('data... ', data)
      return data
    }
  
    Promise.all(skuList.map(sku => checkConcreteAtribute(getCheckData(sku)))).then(results => {  
        // results 是一个数组，包含了每个 checkUserExists 调用解决的结果  
        const wrongs = []
        results.forEach((item, i) => {
          if (item.code !== 200){ 
            wrongs.push(<div>第{i+1}条数据: {item.message}</div>)
          }
        })
        if (wrongs.length > 0) {
          Dialog.confirm({
            message: <>{wrongs}</>,
            confirmButtonText: '继续下单',
            cancelButtonText: '取消',
            onCancel: () => {
              return;
            },
            onConfirm: () => {
              handleCreate({
                skuList,
                selectTradeAgreement,
                shopInfo,
                skuDetail,
                selectAccountPeriod,
                selectStation,
                source,
              });
            }
          });
        } else {
          handleCreate({
            skuList,
            selectTradeAgreement,
            shopInfo,
            skuDetail,
            selectAccountPeriod,
            selectStation,
            source,
          });
        }
    })  
    .catch(error => {  
      // 如果任何一个 promise 失败了，这里的 catch 会被调用  
      console.error('Error:', error);  
    });
    
  };
  return (
    <>
      <div className="footer-row">
        <div className="icons" style={{ flexBasis: disabled ? '83px' : '73px' }}>
          <div className="shopIcon">
            <div
              onClick={() => {
                toShop(shopInfo);
              }}
            >
              <Dp />
              <p>店铺</p>
            </div>
          </div>
          {disabled ? null : (
            <MmuSkuListPopupWithIcon
              source={source}
              showUsePart={showUsePart}
              skuList={skuList}
              selectTradeAgreement={selectTradeAgreement}
              shopInfo={shopInfo}
              skuDetail={skuDetail}
              selectAccountPeriod={selectAccountPeriod}
              selectStation={selectStation}
              station={station}
              setSelectStation={setSelectStation}
              setSkuList={setSkuList}
            />
          )}
        </div>
        {!disabled && getTotalPrice(skuList) ? (
          <span className="footer-price-wrap">
            <span className="footer-price-icon">￥</span>
            {getTotalPrice(skuList)}
          </span>
        ) : null}

        {disabled ? (
          <Button
            text={btnTxt}
            type="primary"
            style={{
              padding: 0,
            }}
            disabled
          />
        ) : (
          <Button
            text="立即下单"
            type="primary"
            style={{
              marginRight: '12px',
              boxShadow: 'none',
              padding: 0,
              width: '110px',
            }}
            disabled={!getTotalPrice(skuList) && !canBuy()}
            onClick={handleSubmit}
          />
        )}
      </div>
      <style jsx>{`
        .footer-row {
          padding: 6px 16px;
          background-color: #fff;
          flex: 0 0 56px;
          display: flex;
          align-items: center;
          padding-bottom: max(constant(safe-area-inset-bottom, 6px), 6px);
          padding-bottom: max(env(safe-area-inset-bottom, 6px), 6px);
          justify-content: space-between;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
        }
        .icons {
          display: flex;
          align-items: center;
        }
        .icons :global(.listIcon) {
          padding-top: 0;
          height: auto;
        }
        .shopIcon {
          flex: 0 0 30px;
        }
        .shopIcon p {
          font-size: 12px;
          transform: scale(0.83);
          margin: 0;
          margin-top: -4px;
          color: #666666;
        }
        .shopIcon :global(svg) {
          transform: scale(0.9);
        }
        .footer-price-wrap {
          font-size: 16px;
          color: #ea5604;
          font-weight: bold;
          margin-left: 15px;
          word-break: break-word;
          flex: 1;
          line-height: 18px;
        }
        .footer-price-icon {
          font-size: 14px;
        }
      `}</style>
    </>
  );
}
